module.exports = __webpack_public_path__ + "96284e2a02af46d9ffa2d189eaad5483.woff2";